module.exports = __webpack_public_path__ + "img/azxy8_icon.9d5e0dec.png";